import React from 'react';
import { IconButton, Snackbar, SnackbarContent } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import { AppContext } from '../../App';
import { styled } from '@mui/system';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const SnackbarContentStyled = styled(SnackbarContent)<{ variant: string }>(
  ({ theme, variant }) => ({
    backgroundColor: theme.palette[variant]?.main || theme.palette['success']?.main,
  })
);

const IconStyled = styled('span')(({ theme }) => ({
  fontSize: 20,
  marginRight: theme.spacing(1),
}));

const SpanStyled = styled('span')({
  display: 'flex',
  alignItems: 'center',
});

const Toast: React.FC = () => {
  const { toast, setToast } = React.useContext(AppContext);

  const handleClose = (_event: React.SyntheticEvent | Event, reason?: string) => {
    // A clickaway is not a dismissal; only a timeout or the close button is.
    if (reason === 'clickaway') {
      return;
    }

    setToast({ ...toast, open: false });
  };

  const IconComponent = variantIcon[toast.variant as keyof typeof variantIcon];

  return (
    <Snackbar
      key={toast.message}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={toast.open}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <SnackbarContentStyled
        variant={toast.variant}
        message={
          <SpanStyled data-cy="client-snackbar">
            {IconComponent && <IconStyled as={IconComponent} />}
            {toast.message}
          </SpanStyled>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={(event) => handleClose(event)}
          >
            <IconStyled as={CloseIcon} />
          </IconButton>,
        ]}
      />
    </Snackbar>
  );
};

export default Toast;
